export default __webpack_public_path__ + "static/media/highway.dceb6eda.png";